<template lang='pug'>
  v-card
    v-card-title
      | Factura # {{item.reference_number}}
      v-spacer
        v-icon(aria-label="Close" @click="$emit('close')")
          | mdi-close
    v-card-subtitle(v-if="item.type !=='purchases' && item.type !== 'expenses'")
      | {{item.location_from.name}}
    v-card-text.body-1.text-center.mt-4
      v-row
        table().ma-auto
          thead
            tr
              th.text-xs-left Cantidad
              th.text-xs-left Referencia
              th.text-xs-left Valor/Unidad
              th.text-xs-left Valor total
          tbody
            tr(v-for='row in item.items')
              th.text-xs-left {{row.amount}}
              td.text-xs-left(style='max-width: 100px;')
                a(@click.stop="showProduct(row)") {{row.name}}
              td.text-xs-left {{row.price}}
      v-btn.mt-6(color="info" depressed="" default="" rounded="" @click="$emit('close')")
        | Ok

</template>

<script>
  const formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  })
  export default {
    name: 'BillPreview',
    filters: {
      moneyFormat: function (value) {
        return formatter.format(value)
      },
      numberFormat (val) {
        if (val) { return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') }
        return '0 '
      },
      translate: function (name) {
        switch (name) {
          case 'sales':
            return 'Venta'

          case 'purchases':
            return 'Compra'

          case 'transfers':
            return 'Traslado'

          case 'returns':
            return 'Devolucion'

          case 'store':
            return 'Tienda'

          case 'warehouse':
            return 'Bodega'
        }
      },

    },
    props: {
      item: Object,
      currentType: String,
    },
    methods: {
      showSupportImage (item) {
        this.$emit('showSupportImage', item)
      },
      showProduct (item) {
        const vm = this
        vm.$store.dispatch('products/setCurrentItem', item).then(function () {
          vm.$emit('showProduct')
        })
      },
      handleStock (val, type) {
        if (type === 'stock') {
          val.trash = val.qty - val.stock
        } else {
          val.stock = val.qty - val.trash
        }
      },
      updateReturn () {
        const vm = this
        vm.$store.dispatch('transactions/updateReturn', vm.item).then(function () {
          vm.$emit('close')
        })
      },
    },

  }
</script>

<style scoped>
</style>
